<template>
    <span class="boldFont" v-if="counts.hasOwnProperty(group)"
          v-text="`(${counts[group][slug]})`"></span>
</template>

<script>
export default {
    name: "FilterCount",
    props: {
        group: {
            required: true,
            type: String,
        },
        slug: {
            required: true,
            type: String,
        },
        counts: {
            required: true,
            type: Object,
        }
    }
}
</script>

<style scoped>

</style>
